export const SelectTrans = ({ width = 100, label, value,fn }) =>{
    return <label className='column'
                  onClick={()=>{fn(value)}}
                  style={{ width: `calc(${width}% - 10px)`, height: `calc(${width}% - 10px)`,
                  border: '1px solid black', borderRadius: '10px',}}>
        <div className='row' style={{alignItems: 'center'}}>
            <input type='radio' className={"inputBorder inputTextAreaMargin"} style={{flexGrow: 0}}/>
            <span style={{height: 'fit-content'}}>{label}</span>
        </div>
        <div style={{textAlign: 'left', padding:10}}>{value}</div>
    </label>
}
